import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SelectOption } from '@app/interfaces/sys/dict';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { AccountService } from '@services/sys/account.service';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { Account } from '@app/interfaces/sys/account';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-assign-member',
    templateUrl: './assign-member.component.html',
    styleUrl: './assign-member.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AssignMemberComponent),
            multi: true,
        },
    ],
})
export class AssignMemberComponent implements OnChanges {
    @Input() initialValue: string[] = [];
    @Input() projectMembers: SelectOption[] = [];
    @Input() clickToEdit = false; // 点击后才编辑
    @Input() formControlName = '';
    @Input() required = false;
    @Input() accountList: Account[] = [];
    @Input() submitLoading = false;
    @Input() inactiveUsers: boolean = false;

    @Output() valueChange = new EventEmitter();
    @ViewChild('selectComponent') selectComponent!: NzSelectComponent;

    currentValue: string[] = [];

    isEditing = false;
    openMenu = false;
    accountData: {
        [userId: number]: Account
    } = {};

    constructor(private accountService: AccountService,
                private message: NzMessageService,
                private kanbanBoardService: KanbanBoardService,
                private modal: NzModalService,
                private confirmationService: ConfirmationService) {
    }

    ngOnInit(): void {
      this.projectMembers = this.projectMembers.filter(it => it.enable);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { accountList, inactiveUsers } = changes;
        if (!this.submitLoading && !inactiveUsers) {
            this.isEditing = false;
        }
        if (accountList) {
            this.accountData = this.accountService.formatAccountList(this.accountList || []);
        }
        this.currentValue = this.initialValue || [];
    }

    onChange: any = () => {
    }
    onTouch: () => void = () => null;

    writeValue(obj: any): void {
        this.currentValue = obj || [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    removeAssignee(personId: string, event: MouseEvent): void {
        event.stopPropagation();
        if (this.currentValue.length === 1 && this.required) {
            this.message.error('This field is required');
            return;
        }
        this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
                this.initialValue = this.initialValue.filter(p => p !== personId);
                this.currentValue = [...this.initialValue];
                this.valueChange.emit(this.currentValue);
            }
        );
    }

    changeSelect(arr: string[]): void {
        if (this.clickToEdit && this.required && (!arr || arr.length === 0)) {
            this.message.error('This field is required');
            return;
        }
        this.onChange(this.currentValue);
    }

    startEditing(): void {
        this.currentValue = [...this.initialValue];
        this.isEditing = true;
        setTimeout(() => {
            this.selectComponent.focus();
            this.openMenu = true;
        }, 200);
    }

    changeValue(): void {
        const sortedCurrent = [...this.currentValue].sort();
        const sortedInitial = [...this.initialValue].sort();

        if (this.arraysAreEqual(sortedCurrent, sortedInitial)) {
            this.isEditing = false;
            this.openMenu = false;
            return;
        }

        this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
                setTimeout(() => {
                    this.valueChange.emit(this.currentValue);
                }, 200);
            }
        );
    }

    private arraysAreEqual(arr1: string[], arr2: string[]): boolean {
        return arr1.length === arr2.length && arr1.every((val, index) => val === arr2[index]);
    }

    openChange(visible: boolean): void {
        if (!this.clickToEdit) {
            return;
        }
        if (this.required && (!this.currentValue || this.currentValue.length === 0)) {
            this.currentValue = this.initialValue;
        }
        this.changeValue();
        if (!visible && this.isEditing) {
            this.isEditing = false;
        }
    }

    getName(fullName: string): string {
        if (!fullName) {
            return '';
        }
        const index = fullName.indexOf(' (');
        return index !== -1 ? fullName.substring(0, index) : fullName;
    }

    closeDropdown(): void {
        this.openMenu = false;
        this.selectComponent?.setOpenState(false);
    }
}
